















































import { RotCalculatorModel } from '@/models/RotCalculatorModel';
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class RotCalculator extends Vue {
    private rot!: RotCalculatorModel;
    private totalSavings: string = '0';
    private kitchenCost: number = 0;
    private installationCost: number = 0;
    private ballingslovDiscount: string = '0';
    private rotDeduction: string = '0';

    constructor() {
        super();
        this.rot = JSON.parse(this.$attrs['data-rot']);
    }

    calculateDeduction() {
        if (this.kitchenCost > 0 && this.installationCost > 0) {
            const kitchenDiscount = this.kitchenCost * 0.2;
            let rotDeduction = this.installationCost * 0.5;
            let infoText = '';
            if (rotDeduction > 100_000) {
                rotDeduction = 100_000;
            }
            if (rotDeduction > 50_000) {
                infoText = 'Förutsatt att det är två personer i hushållet';
            }

            const totalSavings = kitchenDiscount + rotDeduction;

            this.ballingslovDiscount = kitchenDiscount.toLocaleString('sv-SE', {
                style: 'currency',
                currency: 'SEK'
            });
            this.rotDeduction = rotDeduction.toLocaleString('sv-SE', {
                style: 'currency',
                currency: 'SEK'
            });
            this.totalSavings = totalSavings.toLocaleString('sv-SE', {
                style: 'currency',
                currency: 'SEK'
            });
        }
    }

    navigateToKitchens() {
        window.location.href = '/kitchens';
    }
}
